import {aiDrawerViewAtom, openAiSearchAndAskAtom} from 'atoms/aiSearch';
import {ROUTE_PATHS} from 'constant';
import {useSetAtom} from 'jotai';
import {useEffect, useRef} from 'react';
import {useNavigate, useSearchParams} from 'react-router';

import {Home} from './Home';

/**
 * `/ask` renders the normal home surface but opens the AI "Ask" drawer on load.
 * `/ask?query=<text>` additionally pre-fills and sends the question immediately.
 *
 * After firing once we replace the URL with `/` so the drawer simply floats over
 * home and a refresh does not re-send the same question.
 */
export const Ask = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const openAiSearchAndAsk = useSetAtom(openAiSearchAndAskAtom);
  const setDrawerView = useSetAtom(aiDrawerViewAtom);
  const hasFired = useRef(false);

  useEffect(() => {
    if (hasFired.current) {
      return;
    }
    hasFired.current = true;

    const query = (searchParams.get('query') ?? searchParams.get('q') ?? '').trim();

    if (query) {
      openAiSearchAndAsk(query, 'queryparam');
    } else {
      setDrawerView('expanded');
    }

    navigate(ROUTE_PATHS.HOME, {replace: true});
  }, [navigate, openAiSearchAndAsk, searchParams, setDrawerView]);

  return <Home />;
};
